// @flow
let worker: ?Worker = null

export function terminate () {
  if (worker) {
    console.warn('Terminating Fertilizers Worker')
    worker.terminate()
    worker = null
  }
}

export function initialize (): Worker {
  if (worker) {
    terminate()
  }

  console.warn('Initializing Fertilizers Worker')

  // $FlowFixMe
  const FertilizersWorker = require('worker-loader?name=[hash].fertilizers.wrkr.js!./worker.js')
  worker = new FertilizersWorker()
  return worker
}

export function getWorker (): Worker {
  if (worker) {
    return worker
  }

  return initialize()
}

export default {
  terminate,
  initialize,
  getWorker,
}
